<div class="material-datatables">
  <table
    [id]="table_id"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%"
  >
    <thead>
      <tr>
        <th class="disabled-sorting"><b>ID</b></th>
        <th class="disabled-sorting"><b>Name</b></th>
        <th class="disabled-sorting"><b>Company</b></th>
        <th class="disabled-sorting"><b>Phone</b></th>
        <th class="disabled-sorting"><b>Email</b></th>
        <th class="disabled-sorting"><b>Location</b></th>
        <th class="disabled-sorting"><b>Date</b></th>
        <th class="disabled-sorting"><b>Ranking</b></th>
        <th class="disabled-sorting"><b>Source</b></th>
        <th class="disabled-sorting"><b>Re assign</b></th>
        <th class="disabled-sorting text-right"><b>Actions</b></th>
      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer" *ngFor="let item of data">
        <td>{{ item.id }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.company }}</td>
        <td>{{ item.phone }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.location }}</td>
        <td>{{ item.fecha * 1000 | date : "MM/dd/yyyy" }}</td>
        <td>{{ item.ranking }}</td>
        <td>{{ item.source }}</td>
        <td>
          <button
            class="btn btn-outline-warning btn-sm emitir"
            id="changeRep-{{ item.id }}"
          >
            <i
              class="fa fa-user emitir"
              id="changeRep-{{ item.id }}"
              aria-hidden="true"
            ></i>
            &nbsp;
            <i
              class="fa fa-share emitir"
              id="changeRep-{{ item.id }}"
              aria-hidden="true"
            ></i>
          </button>
        </td>
        <td class="text-right">
          <a class="btn btn-link btn-info btn-just-icon like">
            <i class="material-icons emitir" id="show-{{ item.id }}"
              >remove_red_eye</i
            ></a
          >
          <!-- getContactForm(item.id) -->
          <a class="btn btn-link btn-danger btn-just-icon"
            ><i class="material-icons emitir" id="delete-{{ item.id }}"
              >close</i
            ></a
          >

          <!-- <a class="btn btn-link btn-warning btn-just-icon" (click)="saveEmit('changeRep',item.id, item)"><i class="material-icons">camera_front</i></a> -->
        </td>
      </tr>
    </tbody>
  </table>
</div>
